import {Component, OnInit} from '@angular/core';
import {SpecialRequest} from 'src/app/special-request/special-request.model';
import {MessageMenuComponent} from '../messages/message-menu/message-menu.component';
import {SpecialRequestService} from '../../special-request/special-request.service';
import {Filter} from '../../models/warranties/filter.model';
import {MessagesUtil} from './messages-util';
import {AuthService} from '../../auth/auth.service';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  messages: Array<SpecialRequest>;
  filter: Filter = new Filter();

  constructor(private messageMenu: MessageMenuComponent, public specialRequestService: SpecialRequestService,
              private authService: AuthService) {

  }

  ngOnInit(): void {
    if (this.specialRequestService.specialRequests == null) {
      this.specialRequestService.fetchSpecialRequests(this.filter).pipe().subscribe((specialRequests) => {
        console.log('specialRequests', specialRequests);
        this.messageMenu.displayMessagesFromSpecialRequests(MessagesUtil.selectSpecialRequestsNotBeingReviewed(specialRequests));
        this.initMessages(specialRequests);
      });
    } else {
      this.initMessages(this.specialRequestService.specialRequests?.filter(specialRequest => specialRequest.vin !== null));
    }
  }

  initMessages(specialRequests: Array<SpecialRequest>): void {
    this.messages = specialRequests;
    const newMessages = [];
    this.messages?.forEach(specialRequest => {
      specialRequest.dateModified = new Date(specialRequest.dateModified);
      newMessages.push(specialRequest);
    });
    this.messages = newMessages;
    this.messages?.sort((a, b) => b.id - a.id
      && b.dateModified.getTime() - a.dateModified.getTime());
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  readSpecialRequest(id: number) {
    let specialRequest: SpecialRequest;
    this.messageMenu.specialRequestService.readMessage(id).subscribe((res) => {
      specialRequest = this.messages.find((key, value) => key.id === id);
      specialRequest.messageRead = true;
    });

    this.ngOnInit();
  }

  interpolateTemplate(template, args) {
    return Object.entries(args).reduce(
      (result, [arg, val]) => result.replace(`{{${arg}}}`, `${val}`),
      template,
    );
  }
}
